<template>
  <header class="page-header">
    <el-row>
      <el-col
        :span="22"
        :offset="1"
        class="header-bottom"
        style="padding-bottom: 10px"
      >
        <el-row>
          <el-col :span="4" :gutter="20">
            <img
              src="../../../comm/assets/image/hehai.png"
              style="width: 100%"
            />
          </el-col>
          <el-col :span="14" :gutter="20" style="padding-left: 30px">
            <el-menu
              :default-active="activeIndex"
              mode="horizontal"
              class="top-menu"
            >
              <template v-for="menu in $store.state.menus">
                <el-menu-item
                  :key="menu.id"
                  :index="menu.id.toString()"
                  v-if="!menu.children"
                  @click="handleMenuSelect(menu)"
                  >{{ menu.name }}</el-menu-item
                >
                <el-submenu
                  :key="menu.id"
                  :index="menu.id.toString()"
                  v-if="menu.children"
                >
                  <template slot="title">{{ menu.name }}</template>
                  <el-menu-item
                    v-for="subMenu in menu.children"
                    :key="subMenu.id"
                    :index="subMenu.id.toString()"
                    @click="handleMenuSelect(subMenu)"
                    >{{ subMenu.name }}</el-menu-item
                  >
                </el-submenu>
                <!-- <el-menu-item :key="menu.id + '1'" :index="menu.id.toString()" v-if="!menu.children"
                  @click="handleMenuSelect(menu)">科学计算</el-menu-item> -->
              </template>
            </el-menu>
          </el-col>
          <el-col :span="1" :gutter="20">
            <el-popover
              class="custom-theme-box"
              placement="bottom"
              width="160"
              v-model="visible"
            >
              <p>全局主题</p>
              <div style="margin: 0">
                <el-radio-group v-model="defaultTheme" @input="changeTheme">
                  <el-radio
                    v-for="item in themeList"
                    :label="item.key"
                    :key="item.key"
                    >{{ item.value }}</el-radio
                  >
                </el-radio-group>
              </div>
              <img
                slot="reference"
                src="../../../comm/assets/image/skin.png"
                width="22"
                height="22"
                style="margin-right: 20px"
              />
            </el-popover>
          </el-col>
          <el-col :span="5" :gutter="20">
            <div
              style="width: 100%; height: 80px; margin-bottom: 3px"
              v-popover:popover
            >
              <div style="position: relative; width: 100%">
                <div
                  v-for="(cluster, i) in $store.state.clusters"
                  :key="i"
                  class="cluster"
                  :style="`right:${30 * i}px`"
                  @click="switchCluster(i)"
                >
                  <el-row class="cluster-item">
                    <el-col :span="5">
                      <el-avatar
                        size="medium"
                        shape="square"
                        :src="$store.state.user.avatar"
                      ></el-avatar>
                    </el-col>
                    <el-col :span="15" style="margin-top: 12px">
                      <span> {{ $store.state.user.name }}</span>
                      <el-descriptions :column="1">
                        <!-- <el-descriptions-item> -->

                        <!-- </el-descriptions-item> -->
                        <el-descriptions-item label="总费用"
                          >{{
                            feeDetail.totalfee ? feeDetail.totalfee : 0
                          }}元</el-descriptions-item
                        >
                      </el-descriptions>
                    </el-col>
                    <el-col
                      :span="4"
                      style="cursor: pointer; height: 64px; position: relative"
                      :title="cluster.clusterName"
                    >
                      <div class="cluster-name">
                        {{ cluster.clusterName }}
                      </div>
                      <!-- v-popover:clusterNamePopover -->
                      <!-- <el-popover
                        ref="clusterNamePopover"
                        placement="top"
                        width="200"
                        trigger="hover"
                        :content="cluster.clusterName"
                      >
                      </el-popover> -->
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <el-popover
              ref="popover"
              placement="bottom"
              width="250"
              trigger="hover"
            >
              <div>
                <el-row>
                  <el-col :span="6"
                    ><span style="font-weight: bold">个人信息</span>
                  </el-col>
                  <el-col
                    :span="12"
                    v-if="currentCluster.clusterName == 'yunhpc'"
                    style="text-align: center"
                  >
                    <el-button
                      type="text"
                      style="padding: 0; text-align: right"
                      @click="enterInsideDownload"
                      >站内下载</el-button
                    >
                  </el-col>
                  <el-col :span="6" align="right">
                    <el-button
                      type="text"
                      style="padding: 0; text-align: right"
                      @click="enterInsideLetter"
                      >站内信</el-button
                    >
                  </el-col>
                </el-row>

                <el-row style="margin-top: 15px; margin-bottom: 10px">
                  <el-col :span="4">
                    <el-avatar
                      size="small"
                      shape="square"
                      :src="$store.state.user.avatar"
                    ></el-avatar>
                  </el-col>
                  <el-col :span="16">
                    <span style="line-height: 30px">{{
                      $store.state.user.name
                    }}</span>
                    <!-- <el-descriptions :column="1"> -->
                    <!-- <el-descriptions-item label="用户名"></el-descriptions-item> -->
                    <!--                      <el-descriptions-item label="余额"-->
                    <!--                        >{{-->
                    <!--                          feeDetail.balancefee ? feeDetail.balancefee : 0-->
                    <!--                        }}元</el-descriptions-item-->
                    <!--                      >-->
                    <!-- </el-descriptions> -->
                  </el-col>
                </el-row>
                <div>
                  <el-descriptions
                    :column="1"
                    :labelStyle="{ width: '80px' }"
                    :colon="false"
                  >
                    <el-descriptions-item label="账户名">{{
                      $store.state.user.username
                    }}</el-descriptions-item>
                    <el-descriptions-item label="状态">{{
                      $store.state.user.userProperty === "1" ? "正式" : "测试"
                    }}</el-descriptions-item>
                    <el-descriptions-item label="集群名称">{{
                      currentCluster.clusterName
                    }}</el-descriptions-item>
                    <el-descriptions-item label="使用机时"
                      >{{ feeDetail.machineHours }}(核*时)</el-descriptions-item
                    >
                    <el-descriptions-item label="使用卡时"
                      >{{
                        feeDetail.gpuHours.toFixed(2)
                      }}(卡*时)</el-descriptions-item
                    >
                    <!--                    <el-descriptions-item label="普通机时费">{{ feeDetail.jobfee }}元</el-descriptions-item>-->
                    <!--                    <el-descriptions-item label="包节点/核时费">{{ feeDetail.contractNodeFee}}元/{{ feeDetail.contractMachineHoursFee}}元</el-descriptions-item>-->
                    <el-descriptions-item label="总费用"
                      >{{ feeDetail.totalfee }}元</el-descriptions-item
                    >
                  </el-descriptions>
                </div>
                <div>
                  <el-row style="margin-top: 15px">
                    <!--                  <el-col :span="6">-->
                    <!--                    <el-button type="text" style="padding: 0;">我的钱包</el-button>-->
                    <!--                  </el-col>-->
                    <el-col :span="8">
                      <el-button type="text" style="padding: 0" @click="enterMe"
                        >个人中心</el-button
                      >
                    </el-col>
                    <el-col :span="8" align="center">
                      <el-button
                        type="text"
                        style="padding: 0"
                        @click="enterChangePassword"
                        >修改密码</el-button
                      >
                    </el-col>
                    <el-col :span="8" align="right">
                      <el-button type="text" style="padding: 0" @click="logout"
                        >退出</el-button
                      >
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-popover>
            <div>
              <el-progress
                :percentage="currentCluster.storagePercent"
                :show-text="false"
              ></el-progress>
            </div>
            <div>
              <el-row>
                <el-col :span="10" :offset="14">
                  <span class="kbNum"
                    >{{ currentCluster.usedStorage }}/{{
                      currentCluster.totalStorage
                    }}</span
                  >
                  <!--                  <el-button type="text" style="padding: 0" @click="logout">扩容</el-button>-->
                </el-col></el-row
              >
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <change-password
      ref="changePasswordRef"
      @handleChangePwdSuccess="handleChangePwdSuccess"
    ></change-password>
  </header>
</template>
<script>
import { lib } from "../../../comm/assets/js/lib";
import ChangePassword from "../../../comm/components/ChangePassword";
export default {
  components: { ChangePassword },
  name: "page-header",
  inject: ["mainReload"],
  data() {
    return {
      activeIndex: "-1",
      feeDetail: {
        balancefee: undefined,
        machineHours: undefined,
        jobfee: undefined,
        contractNodeFee: undefined,
        contractMachineHoursFee: undefined,
        totalfee: undefined,
        gpuHours: undefined
      },
      currentCluster: {
        clusterName: undefined,
        storagePercent: 0,
        totalStorage: 0,
        usedStorage: 0
      },
      defaultTheme: localStorage.getItem("theme"),
      themeList: window.themeConfig
    };
  },
  computed: {},
  methods: {
    enterInsideDownload() {
      //获得token
      let tokenData = lib.cookie.get("Hpc-Platform-Token");

      this.http
        .get("/client/file/downloadkey", {
          headers: { token: tokenData },
          responseType: "blob"
        })
        .then(response => {
          let blob = new Blob([response.data], {
            //这里的type要和后端一致
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let Url = URL.createObjectURL(blob); //生成一个url
          const a = document.createElement("a");
          a.href = Url;
          a.download = this.$store.state.user.username + ".txt";
          a.click();
          window.URL.revokeObjectURL(Url);
        });
    },
    changeTheme(val) {
      localStorage.setItem("theme", val);
      location.reload();
    },
    // isMenuActived(menu){
    //   return menu.path === this.$route.path?'is-active':''
    // },
    enterInsideLetter() {
      this.$store.commit("addActivedMenu", {
        path: "/insideLetter",
        name: "站内信"
      });
      this.$router.push({ path: "/insideLetter" });
    },
    enterMe() {
      this.$store.commit("addActivedMenu", {
        path: "/Me",
        name: "个人中心"
      });
      this.$router.push({ path: "/Me" });
    },
    enterChangePassword() {
      // this.$store.commit("addActivedMenu", {
      //   path: '/changePassword',
      //   name: '修改密码'
      // })
      // this.$router.push('ChangePassword')
      this.$refs.changePasswordRef.showChangePassword();
    },
    handleChangePwdSuccess() {
      this.logout();
    },
    handleMenuSelect(menu) {
      let _that = this;
      if (menu.target === "Y") {
        window.open(`/#${menu.clientPath}`, "_blank");
      } else {
        this.$store.commit("addActivedMenu", {
          path: menu.clientPath,
          name: menu.name
        });
        this.$router.push({ path: menu.clientPath });
      }
    },
    getFeeDetail() {
      this.http.get("/client/fee/detail").then(res => {
        this.feeDetail = res.data;
      });
    },
    switchCluster(index) {
      let store = this.$store;
      let clusters = store.state.clusters;
      let cluster = clusters[index];
      clusters[index] = clusters[clusters.length - 1];
      clusters[clusters.length - 1] = cluster;
      store.commit("updatecurrentCluster", cluster);
      lib.cookie.set("HEAD-CLUSTER-NAME", cluster.clusterName);
      store.commit("updateClusters", clusters);
      this.$forceUpdate();
      //todo 集群切换后续动作
      this.currentCluster.clusterName = cluster.clusterName;
      this.currentCluster.storagePercent = cluster.storagePercent
        ? cluster.storagePercent
        : 0;
      this.currentCluster.totalStorage = cluster.totalStorage
        ? cluster.totalStorage
        : 0;
      this.currentCluster.usedStorage = cluster.usedStorage
        ? cluster.usedStorage
        : 0;
      this.getFeeDetail();
      this.mainReload();
    },
    logout() {
      lib.cookie.del("Hpc-Platform-Token");
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
      this.$router.push({ path: "/login" });
    }
  },
  created() {
    window.store = this.$store;
    window._that = this;
    if (!this.$store.state.user.name) {
      if (
        lib.cookie.get("Hpc-Platform-Token") &&
        lib.sessionStorage.get("name")
      ) {
        this.$store.commit("updateUser", {
          name: lib.sessionStorage.get("name"),
          avatar: lib.sessionStorage.get("avatar"),
          balance: lib.sessionStorage.get("balance"),
          userProperty: lib.sessionStorage.get("userProperty"),
          username: lib.sessionStorage.get("username")
        });
        let menusString = lib.sessionStorage.get("menus");
        this.$store.commit("updateMenus", JSON.parse(menusString));

        if (this.$route.name !== "Index") {
          this.$store.commit("addActivedMenu", {
            path: this.$route.path,
            name: this.$route.meta.title
          });
        }
      } else {
        this.$router.push({ path: "/login" });
      }
    } else {
      lib.generateRoutes(this.$router, this.$store.state.menus);
    }
    this.http.get("/client/clusters/", {}).then(res => {
      // console.log("clusters", res);
      // 集群列表
      const clustersArr = [];
      if (res.data && res.data.length) {
        res.data = res.data.reverse();
        const currentClusterName = lib.cookie.get("HEAD-CLUSTER-NAME");
        let currentClusterIndex = null;
        res.data.forEach((element, i) => {
          let obj = {};
          if (element.clusterName === currentClusterName) {
            currentClusterIndex = i;
          }
          obj.clusterName = element.clusterName;
          obj.storagePercent = element.storagePercent
            ? element.storagePercent
            : 0;
          obj.totalStorage = element.totalStorage ? element.totalStorage : 0;
          obj.usedStorage = element.usedStorage ? element.usedStorage : 0;
          clustersArr.push(obj);
        });
        if (currentClusterName) {
          let arr = clustersArr;
          if (currentClusterIndex === 0) {
            arr = arr.reverse();
          }
          let index = arr.length - 1;
          this.$store.commit("updateClusters", arr);
          this.$store.commit("updatecurrentCluster", arr[index]);
          this.currentCluster.clusterName = arr[index].clusterName;
          this.currentCluster.storagePercent = arr[index].storagePercent
            ? arr[index].storagePercent
            : 0;
          this.currentCluster.totalStorage = arr[index].totalStorage
            ? arr[index].totalStorage
            : 0;
          this.currentCluster.usedStorage = arr[index].usedStorage
            ? arr[index].usedStorage
            : 0;
          // lib.cookie.set('HEAD-CLUSTER-NAME', arr[currentClusterIndex].clusterName)
        } else {
          this.$store.commit("updateClusters", clustersArr);
          // 设置最后一个集群为当前集群
          let index = res.data.length - 1;
          this.$store.commit("updatecurrentCluster", clustersArr[index]);
          this.currentCluster.clusterName = res.data[index].clusterName;
          this.currentCluster.storagePercent = res.data[index].storagePercent
            ? res.data[index].storagePercent
            : 0;
          this.currentCluster.totalStorage = res.data[index].totalStorage
            ? res.data[index].totalStorage
            : 0;
          this.currentCluster.usedStorage = res.data[index].usedStorage
            ? res.data[index].usedStorage
            : 0;
          lib.cookie.set("HEAD-CLUSTER-NAME", res.data[index].clusterName);
        }
      }
      // this.$store.commit("updatecurrentCluster", {
      //   clusterName: res.data[0].clusterName,
      //   storagePercent: res.data[0].storagePercent
      //     ? res.data[0].storagePercent
      //     : 0,
      //   totalStorage: res.data[0].totalStorage ? res.data[0].totalStorage : 0,
      //   usedStorage: res.data[0].usedStorage ? res.data[0].usedStorage : 0,
      // })
      // this.currentCluster.clusterName = res.data[0].clusterName
      // this.currentCluster.storagePercent = res.data[0].storagePercent ? res.data[0].storagePercent : 0
      // this.currentCluster.totalStorage = res.data[0].totalStorage ? res.data[0].totalStorage : 0
      // this.currentCluster.usedStorage = res.data[0].usedStorage ? res.data[0].usedStorage : 0
      // lib.cookie.set('HEAD-CLUSTER-NAME', res.data[0].clusterName)
    });
    this.getFeeDetail();
    let _that = this;
    for (let menu of this.$store.state.menus) {
      let path = this.$route.path;
      if (menu.children) {
        for (let subMenu of menu.children) {
          if (subMenu.clientPath === path) {
            _that.activeIndex = subMenu.id.toString();
            break;
          }
        }
      } else if (menu.clientPath === path) {
        this.activeIndex = menu.id.toString();
        break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-theme-box {
  height: 60px;
  line-height: 74px;
  display: flex;
  justify-content: right;
}

/deep/ .el-radio {
  margin: 10px 5px;
  display: block;
}

.page-header {
  width: 100%;
  padding: 10px 0;
}

.cluster {
  position: absolute;
  background: #3c4957;
  border: 1px solid grey;
  border-radius: 12px;
  color: #fff;
  padding: 5px;

  &:last-child {
    border-color: #dcd4d4;
    background: #5a6c81;
  }

  &:hover {
    border-color: #dcd4d4;
    background: #5a6c81;
  }

  .cluster-name {
    transform: rotate(90deg) !important;
    // height: 35px;
    height: 100%;
    overflow: hidden;
    width: 64px;
    text-overflow: ellipsis;
    top: 5px;
    position: absolute;
    right: 0;
    // left: 0;
    // padding-top: 40px;
    // padding-left: 20px;
  }

  .el-avatar {
    margin-top: 15px;
  }
}
</style>
<style lang="scss">
.cluster {
  .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/workspace/views/layout/Header.vue